import { z } from 'zod'

export const suggestionSchema = z.object({
  composer: z
    .string()
    .min(1, 'Composer is required')
    .max(100, 'Composer must be at most 100 characters'),
  title: z.string().min(1, 'Title is required').max(200, 'Title must be at most 200 characters'),
  // Wikidata IDs are optional now - if missing, entry is treated as freetext
  composer_wikidata_id: z.string().optional().nullable(),
  work_wikidata_id: z.string().optional().nullable(),
  comment: z
    .string()
    .max(1000, 'Comment must be at most 1000 characters')
    .optional()
    .or(z.literal('')),
})

export type SuggestionFormData = z.infer<typeof suggestionSchema>
